import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FcpivotRoutingModule} from "./fcpivot-routing.module";
import {
  DxChartModule,
  DxAutocompleteModule,
  DxDataGridModule,
  DxPopupModule,
  DxDropDownButtonModule,
  DxPivotGridModule,
  DxCheckBoxModule,
  DxScrollViewModule,
  DxLoadPanelModule,
  DxButtonModule,
  DxPivotGridFieldChooserModule,
  DxTooltipModule
} from "devextreme-angular";
import { FcpivotComponent } from "./fcpivot.component";

@NgModule({
  imports: [
    CommonModule,
    FcpivotRoutingModule,
    DxChartModule,
    DxScrollViewModule,
    DxAutocompleteModule,
    DxDataGridModule,
    DxPopupModule,
    DxButtonModule,
    DxDropDownButtonModule,
    DxPivotGridModule,
    DxPivotGridFieldChooserModule,
    DxCheckBoxModule,
    DxLoadPanelModule,
    DxTooltipModule
  ],
  declarations: [FcpivotComponent],
})
export class FcpivotModule{}
